import { useEffect, useState } from "react";
import { PaginatorPageChangeEvent } from "primereact/paginator";
import { useApiQuery } from "../../../../../common/infrastructure/hooks/useApiQuery";
import { useApiMutation } from "../../../../../common/infrastructure/hooks/useApiMutation";
import { endpointsMetadata } from "../../../../../common/infrastructure/routes/endpointsMetadata";
import { constructCancelSmsEndpoint } from "../../../../../common/infrastructure/routes/endpointsHelpers";
import { IPaginatedResponse } from "../../emailLogs/models/emailLogModel";
import { ISmsLogModel } from "../models/smsLogModel";

const PAGE_SIZE = 20;

interface IUseSmsLogsListParams {
  filterUserIds: number[] | null;
}

export const useSmsLogsList = ({ filterUserIds }: IUseSmsLogsListParams) => {
  const [page, setPage] = useState(1);
  const [selectedSms, setSelectedSms] = useState<ISmsLogModel | null>(null);

  useEffect(() => {
    setPage(1);
  }, [filterUserIds]);

  const listParams = new URLSearchParams({ page: page.toString(), pageSize: PAGE_SIZE.toString() });
  filterUserIds?.forEach((id) => listParams.append("userIds", id.toString()));
  const listEndpoint = `${endpointsMetadata.communicationLogs.getSmsLogs}?${listParams.toString()}`;

  const { data, isLoading } = useApiQuery<IPaginatedResponse<ISmsLogModel>>({
    queryKey: [endpointsMetadata.communicationLogs.getSmsLogs, page, filterUserIds],
    endpoint: listEndpoint,
    globalIsLoading: false,
  });

  const { mutate: cancelSms, isLoading: isCancelling } = useApiMutation({
    onSuccess: () => setSelectedSms(null),
  });

  const handlePageChange = (e: PaginatorPageChangeEvent) => {
    setPage(Math.floor(e.first / PAGE_SIZE) + 1);
  };

  const handleCancel = () => {
    if (!selectedSms) return;
    cancelSms({
      endpoint: constructCancelSmsEndpoint(selectedSms.id),
      method: "put",
      payload: {},
      successMessage: "SMS-ът е отменен.",
      invalidateKeys: [[endpointsMetadata.communicationLogs.getSmsLogs, page, filterUserIds]],
    });
  };

  const items = data?.items ?? [];
  const totalCount = data?.totalCount ?? 0;

  return {
    page,
    items,
    totalCount,
    isLoading,
    isCancelling,
    selectedSms,
    setSelectedSms,
    handlePageChange,
    handleCancel,
    PAGE_SIZE,
  };
};
